import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { CommonModal } from 'src/components/shared/CommonModal'
import { redactSensitiveJson } from 'src/utils/paymentsOps/redactSensitiveJson'

interface Props {
  title: string
  /** `null` closes the modal. */
  value: unknown | null
  onClose(): void
}

/**
 * Raw JSON in the same `<pre>` treatment as the webhook delivery details. Account and routing
 * numbers are masked — they are never shown in full outside their entry field.
 */
const JsonPreviewModalComponent = ({ title, value, onClose }: Props) => {
  const formatted = useMemo(() => {
    if (value === null || value === undefined) {
      return ''
    }

    return JSON.stringify(redactSensitiveJson(value), null, 2)
  }, [value])

  return (
    <CommonModal
      isOpen={value !== null && value !== undefined}
      title={title}
      className={tw`max-w-[640px]`}
      onClose={onClose}
    >
      <pre
        data-testid="payments-ops-json-preview"
        css={tw`m-0 max-h-[60vh] overflow-auto rounded-lg bg-shades-50 p-3 text-xs`}
      >
        {formatted}
      </pre>
    </CommonModal>
  )
}

export const JsonPreviewModal = memo(JsonPreviewModalComponent)
